import React from "react";
import Home from "../screens/Home/Home";
import Login from "../screens/Login/Login";
import Profile from "../screens/Profile/Profile";
import Register from "../screens/Register/Register";
import ItemDetails from "../screens/ItemDetails/ItemDetails";
import CollectionDetails from "../screens/CollectionDetails/CollectionDetails";
import SubscriptionPlans from "../screens/SubscriptionPlans/SubscriptionPlans";
import OrderSummary from "../screens/OrderSummary/OrderSummary";
import Payments from "../screens/Payments/Payments";
import AddNewCard from "../screens/AddNewCard/AddNewCard";
import Forgot from "../screens/Forgot/Forgot";
import ChangePassword from "../screens/ChangePassword/ChangePassword";
import Settings from "../screens/Settings/Settings";
import CreateCollection from "../screens/CreateCollection/CreateCollection";
import UploadNFT from "../screens/UploadNFT/UploadNFT";
import EditProfile from "../screens/EditProfile/EditProfile";
import EditCard from "../screens/EditCard/EditCard";
import Subscription from "../screens/Subscription/Subscription";
import Terms from "../screens/Terms/Terms";
import Privacy from "../screens/Privacy/Privacy";
import Test from "../screens/Test/Test";
import Contact from "../screens/Contact/Contact";
import About from "../screens/About/About";
import SubscriptionSuccess from "../screens/SubscriptionSuccess/SubscriptionSuccess";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

const AppRoutes = () => {
  return (
    <Router>
      <Routes>
        {/* auth */}
        <Route exact path="/auth/login" element={<Login />} />
        <Route exact path="/auth/register" element={<Register />} />
        <Route exact path="/auth/forgot" element={<Forgot />} />
        <Route
          exact
          path="/auth/change-password"
          element={<ChangePassword />}
        />

        {/* home */}
        <Route exact path="/" element={<Home />} />

        {/* user */}
        <Route exact path="/settings" element={<Settings />} />
        <Route exact path="/profile" element={<Profile />} />
        <Route exact path="/edit-profile" element={<EditProfile />} />

        {/* collections */}
        <Route
          exact
          path="/explore-collection"
          element={<CollectionDetails />}
        />
        <Route exact path="/create-collection" element={<CreateCollection />} />

        {/* nfts */}
        <Route exact path="/upload-nft" element={<UploadNFT />} />
        <Route exact path="/item" element={<ItemDetails />} />

        {/* subscriptions */}
        <Route
          exact
          path="/subscription-plans"
          element={<SubscriptionPlans />}
        />
        <Route exact path="/order-summary" element={<OrderSummary />} />
        <Route exact path="/payments" element={<Payments />} />
        <Route exact path="/add-new-card" element={<AddNewCard />} />
        <Route exact path="/edit-card" element={<EditCard />} />
        <Route exact path="/subscription" element={<Subscription />} />
        <Route exact path="/success" element={<SubscriptionSuccess />} />

        {/* other */}
        <Route exact path="/terms" element={<Terms />} />
        <Route exact path="/privacy" element={<Privacy />} />
        <Route exact path="/contact" element={<Contact />} />
        <Route exact path="/about" element={<About />} />

        <Route exact path="/test" element={<Test />} />
      </Routes>
    </Router>
  );
};

export default AppRoutes;
